export function sortBasedOnAnotherArr<T = string>(
  value1: T,
  value2: T,
  orderArray: T[]
) {
  return orderArray.indexOf(value1) - orderArray.indexOf(value2);
}
